import { Type } from 'class-transformer';
import { exportField, ExportField } from './export.model';

export class Anagrafica {
  id!: number;
  titolo!: string;
  nome!: string;
  cognome!: string;
  numiscr!: string;
  sezione!: string;
  settorea!: boolean;
  settoreb!: boolean;
  settorec!: boolean;
  indirizzo!: string;
  tel!: string;
  fax!: string;
  email!: string;
  cellulare!: string;
  indirizzoattivita!: string;
  telattivita!: string;
  laurea!: string;
  datalaurea!: string;
  universitalaurea!: string;
  annoesamestato!: string;
  luogoesamestato!: string;
  dataiscrizione!: string;
  provvedimenti!: string;
  bio?: string;
  pec!: string;

  numSez2!: number;
  settAsez2!: boolean;
  settBsez2!: boolean;
  settCsez2!: boolean;
  sez2!: string;

  annoEsameStatoSez2!: number;
  dataLaureaSez2!: string;
  dataiscrSez2!: string;
  laureaSez2!: string;
  univLaureaSez2!: string;
  cap!: string;
  comune!: string;
  provincia!: string;

}

export class AnagraficaRequest {
  pfx!: string;
  nome!: string;
  cognome!: string;
  numiscr!: string;
  sezione!: string;
  settorea!: boolean;
  settoreb!: boolean;
  settorec!: boolean;
  spec1!: string;
  spec2!: string;
  spec3!: string;
  iscdal?: string;
  iscal?: string;
  laurea!: string;
  comune!: string;
  occupazione!: string;
  idelenco!: string;
  stp: boolean = false;
  @Type(exportField)
  export?: ExportField;
}

export enum AnagraficaSezione {
  A = 'a',
  B = 'b'
}
